'use client';

import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

const hideNativeSplash = async () => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  await SplashScreen.hide();
};

void CapacitorUpdater.notifyAppReady()
  .then(hideNativeSplash)
  .catch(console.error);

export const CapgoAppReady: React.FC = () => null;
